import { Lesson } from "@packages/store/models/Lesson/LessonModel";

export function getLessonsTotalDurationHours(lessons: Lesson[]) {
  return lessons
    .filter((lesson) => !lesson.compensation)
    .reduce((total, lesson) => {
      return total + lesson.exactDuration;
    }, 0);
}
